// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_2zxaw0DN-5jqJr0hv0Jr0d"};